import { DalaWordmark } from "../assets/svg/DalaWordmark";

export const Splash = () => {
  return (
    <div className="flex h-screen w-screen items-center justify-center bg-greyscale-50 dark:bg-primary-900">
      <DalaWordmark className="text-primary-600 dark:text-greyscale-50" />
    </div>
  );
};
